import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {path: '/',redirect: '/home'},
        {path: '/home',name: 'home',component: resolve => require(['@/view/HomePage'], resolve),meta: {title: '四川天烨智芯科技有限公司'}},
        {path: '/SmartTerminal',name: 'SmartTerminal',component: resolve => require(['@/view/SmartTerminal'], resolve),meta: {},},
        {path: '/CoreTechnology',name: 'CoreTechnology',component: resolve => require(['@/view/CoreTechnology'], resolve),meta: {},},
        {path: '/CUBE10',name: 'CUBE10',component: resolve => require(['@/view/ProductCenter/CUBE10'], resolve),meta: {},},
        {path: '/DB10',name: 'DB10',component: resolve => require(['@/view/ProductCenter/DB10'], resolve),meta: {},},
        {path: '/T10',name: 'T10',component: resolve => require(['@/view/ProductCenter/T10'], resolve),meta: {},},

        {path: '/pinghu',name: 'pinghu',component: resolve => require(['@/view/technology/pinghu'], resolve),meta: {},},
        {path: '/gaoxia',name: 'gaoxia',component: resolve => require(['@/view/technology/gaoxia'], resolve),meta: {},},
        {path: '/luban',name: 'luban',component: resolve => require(['@/view/technology/luban'], resolve),meta: {},},
        {path: '/r1',name: 'r1',component: resolve => require(['@/view/ProductCenter/r1'], resolve),meta: {},},
        {path: '/ne100',name: 'ne100',component: resolve => require(['@/view/ProductCenter/ne100'], resolve),meta: {},},
        {path: '/ne101',name: 'ne101',component: resolve => require(['@/view/ProductCenter/ne101'], resolve),meta: {},},
        {path: '/TM10',name: 'TM10',component: resolve => require(['@/view/ProductCenter/TM10'], resolve),meta: {},},
        // {path: '/cube1050',name: 'cube1050',component: resolve => require(['@/view/ProductCenter/cube1050'], resolve),meta: {},},






        {path: '/Scheme1',name: 'Scheme1',component: resolve => require(['@/view/IntelligentDriving/Scheme1'], resolve),meta: {},},
        {path: '/Scheme2',name: 'Scheme2',component: resolve => require(['@/view/IntelligentDriving/Scheme2'], resolve),meta: {},},
        {path: '/Scheme3',name: 'Scheme3',component: resolve => require(['@/view/IntelligentDriving/Scheme3'], resolve),meta: {},},
        {path: '/Scheme4',name: 'Scheme4',component: resolve => require(['@/view/IntelligentDriving/Scheme4'], resolve),meta: {},},
        {path: '/Scheme5',name: 'Scheme5',component: resolve => require(['@/view/IntelligentDriving/Scheme5'], resolve),meta: {},},

        {path: '/transmission',name: 'transmission',component: resolve => require(['@/view/PowerIndustry/transmission'], resolve),meta: {},},
        {path: '/substation',name: 'substation',component: resolve => require(['@/view/PowerIndustry/substation'], resolve),meta: {},},
        {path: '/distribution',name: 'distribution',component: resolve => require(['@/view/PowerIndustry/distribution'], resolve),meta: {},},

        {path: '/ks',name: 'ks',component: resolve => require(['@/view/IntelligentDriving/ks'], resolve),meta: {},},
        {path: '/city',name: 'city',component: resolve => require(['@/view/IntelligentDriving/city'], resolve),meta: {},},

        {path: '/SchemeTm10',name: 'SchemeTm10',component: resolve => require(['@/view/IntelligentDriving/SchemeTm10'], resolve),meta: {},},
        {path: '/SchemeNe100',name: 'SchemeNe100',component: resolve => require(['@/view/IntelligentDriving/SchemeNe100'], resolve),meta: {},},




        {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            // title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            // title: '公司介绍'
          }
        },
        {
          path: '/AIDC',
          name: 'AIDC',
          component: resolve => require(['@/view/AIDC'], resolve),
          meta: {
            // title: '工作机会'
          }
        },
        {
          path: '/recruitment',
          name: 'recruitment',
          component: resolve => require(['@/view/Recruitment'], resolve),
          meta: {
            title: '人才招聘 - 四川天烨智芯科技有限公司'
          }
        },
        {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            // title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            // title: '相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js